import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { LinkContainer } from 'react-router-bootstrap';
import NFButton from '../../primitives/NFButton';
import msgs from '../../../config/messages';
import formConfig from './formConfig';
import { homeRoute } from '../../../config/navigation/routes';
import './PdmiForm.scss';

export default class PdmiForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
  };

  static defaultProps = {
    initialValues: {},
  };

  handleSubmit = async values => {
    console.log('values below!');
    console.log(JSON.stringify(values));



  };

  render() {
    const { onSubmit, initialValues } = this.props;

    return (
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={values => {
          const errors = {};
          if (values.passwordConfirmation !== values.password) {
            errors.passwordConfirmation =
              'Password confirmation does not match password';
          }
          return errors;
        }}
        render={({ handleSubmit, pristine, invalid }) => (
          <form className="nf-pdmi-form" onSubmit={handleSubmit}>
            <div>
              {formConfig.map(fieldConfig => (
                <Field key={fieldConfig.name} {...fieldConfig} />
              ))}
              <Row>
                <Col sm={{ size: 7, offset: 2 }} className="text-center">
                  <LinkContainer to={homeRoute}>
                    <NFButton className="nf-button--gray-border">
                      {msgs.Form.cancelButton}
                    </NFButton>
                  </LinkContainer>
                  <NFButton
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    disabled={pristine || invalid}
                  >
                    {msgs.Form.submitButton}
                  </NFButton>
                </Col>
              </Row>
            </div>
          </form>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/PdmiForm/PdmiForm.jsx